import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLeafIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 16,
	viewBox: "0 0 20 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M8.63281 15.1016C7.07259 15.1016 5.57628 14.4818 4.47304 13.3786C3.36979 12.2753 2.75 10.779 2.75 9.21881C2.75 0.687556 13.0156 5.07037 17.9609 0.968806C18.0174 0.934284 18.0823 0.916016 18.1484 0.916016C18.2146 0.916016 18.2795 0.934284 18.3359 0.968806C18.3965 0.994998 18.4497 1.03584 18.4906 1.08766C18.5315 1.13948 18.5589 1.20065 18.5703 1.26568C20.0781 10.0626 13.5703 15.1016 8.63281 15.1016Z",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M10.9844 7.64844C8.54637 8.31965 6.26189 9.4579 4.25781 11L1.21094 13.6016",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgLeafIcon;
